import { CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE } from '../constants';
import { TChatGroupId } from '../../../../../../types/rest/IRestChatGroup';

export const getLastChatGroupIdLocalStorage = (): TChatGroupId => {
    const data = localStorage.getItem(CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE);
    return data ? JSON.parse(data) : null;
}
